import React from 'react';
import { TaskStatusModal } from './TaskStatusModal';

interface MarkCompleteModalProps {
  visible: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

export const MarkCompleteModal: React.FC<MarkCompleteModalProps> = (props) => {
  return <TaskStatusModal {...props} status="complete" />;
};
